const DEFAULT_OPERATOR_KEYS = [
  'EQUALS',
  'NOT_EQUALS',
  'GREATER_THAN',
  'LESS_THAN',
  'CONTAINS',
  'NOT_CONTAINS',
  'IS_NULL',
  'IS_NOT_NULL',
];

const OPERATOR_TRANSLATION_KEYS = {
  VALUE_OLDER_THAN: 'Consumers.Filter.createDialog.operators.valueOlderThan',
  EQUALS: 'Consumers.Filter.createDialog.operators.equals',
  NOT_EQUALS: 'Consumers.Filter.createDialog.operators.notEquals',
  GREATER_THAN: 'Consumers.Filter.createDialog.operators.greaterThan',
  LESS_THAN: 'Consumers.Filter.createDialog.operators.lessThan',
  CONTAINS: 'Consumers.Filter.createDialog.operators.contains',
  NOT_CONTAINS: 'Consumers.Filter.createDialog.operators.notContains',
  IS_NULL: 'Consumers.Filter.createDialog.operators.isNull',
  IS_NOT_NULL: 'Consumers.Filter.createDialog.operators.isNotNull',
};

const OPERATOR_VALUE_TYPE_RULES = {
  VALUE_OLDER_THAN: ['json', 'string', 'number', 'boolean'],
  EQUALS: ['string', 'number', 'boolean'],
  NOT_EQUALS: ['string', 'number', 'boolean'],
  GREATER_THAN: ['number'],
  LESS_THAN: ['number'],
  CONTAINS: ['string'],
  NOT_CONTAINS: ['string'],
  IS_NULL: ['json', 'string', 'number', 'boolean'],
  IS_NOT_NULL: ['json', 'string', 'number', 'boolean'],
};

function getTranslationKey(key) {
  return OPERATOR_TRANSLATION_KEYS[key];
}

export function createComparisonOperatorOptions(
  translate,
  { allowedKeys = DEFAULT_OPERATOR_KEYS, includeValueOlderThan = false } = {}
) {
  const keys = includeValueOlderThan ? ['VALUE_OLDER_THAN', ...allowedKeys] : allowedKeys;
  return keys.map((key) => {
    const translationKey = getTranslationKey(key);
    return {
      key,
      value: key,
      label: translationKey ? translate(translationKey) : key,
    };
  });
}

export function filterComparisonOperators(operators, { valueType } = {}) {
  const allowedValueTypes = ['string', 'number', 'boolean', 'json'];

  if (!allowedValueTypes.some((f) => f === valueType.toLowerCase())) {
    valueType = 'number';
  }
  return operators.filter((operator) => {
    const allowedTypes = OPERATOR_VALUE_TYPE_RULES[operator.key];
    if (!allowedTypes || allowedTypes.length === 0 || !valueType || allowedTypes.includes(valueType)) {
      return true;
    }
    return false;
  });
}
